<script setup lang="ts">
import AuthSimpleLayout from "@/views/layouts/AuthSimpleLayout.vue";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();

async function handleLogin() {
    // await authStore.signIn("/ask");
    router.push("/ask");
}

async function handleLogout() {
    await authStore.signOut();
}
</script>

<template>
    <AuthSimpleLayout>
        <section class="">
            <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
                <a href="#" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
                    <img class="w-30 h-30 mr-2" src="@/assets/images/optix.png" alt="logo">
                </a>
                <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                            Optix by ITS
                        </h1>
                        <p>
                            Sign in using your Microsoft account
                        </p>
                        <button
                            v-if="!authStore.isAuthenticated"
                            @click="handleLogin"
                            type="button" class="w-full text-white bg-brand box-border border border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none">
                            Sign in
                        </button>
                        <button v-else @click="handleLogout">
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </AuthSimpleLayout>
</template>

<style scoped>

</style>